// import { apiFetch } from "./apiFetch";

// export const vendorApi = {
//   /* =========================
//      AUTH / DASHBOARD
//   ========================= */

//   me: (vendorId, token) =>
//     apiFetch(`/vendor/auth/me.php?id=${encodeURIComponent(vendorId)}`, {
//       method: "GET",
//       token,
//     }),

//   /* =========================
//      PRODUCTS
//   ========================= */

//   products: (token, vendor_id) =>
//     apiFetch(
//       `/vendor/products/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
//       { method: "GET", token },
//     ),

//   addProduct: (token, payload) =>
//     apiFetch("/vendor/products/add.php", {
//       method: "POST",
//       token,
//       body: payload,
//     }),

//   deleteProduct: (token, id) =>
//     apiFetch("/vendor/products/delete.php", {
//       method: "POST",
//       token,
//       body: { id },
//     }),

//   /* =========================
//      CATEGORIES
//   ========================= */

//   mainCategories: (token) =>
//     apiFetch("/vendor/main_categories/list.php", {
//       method: "GET",
//       token,
//     }),

//   subCategoriesByMain: (token, main_category_id) =>
//     apiFetch(
//       `/vendor/sub_categories/list.php?main_category_id=${encodeURIComponent(main_category_id)}`,
//       { method: "GET", token },
//     ),

//   /* =========================
//      ORDERS
//   ========================= */

//   orders: (token, vendor_id) =>
//     apiFetch(
//       `/vendor/orders/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
//       { method: "GET", token },
//     ),

//   orderDetails: (token, order_id) =>
//     apiFetch(
//       `/vendor/orders/details.php?order_id=${encodeURIComponent(order_id)}`,
//       { method: "GET", token },
//     ),

//   monthlyOrders: (token, year) => {
//     const y = year || new Date().getFullYear();
//     return apiFetch(
//       `/vendor/orders/monthly.php?year=${encodeURIComponent(y)}`,
//       { method: "GET", token },
//     );
//   },

//   updateOrderStatus: (token, order_id, status) =>
//     apiFetch("/vendor/orders/update_status.php", {
//       method: "POST",
//       token,
//       body: { order_id, status },
//     }),

//   /* =========================
//      PAYOUTS / WALLET
//   ========================= */

//   // ✅ Wallet fetch (USE THIS ONLY)
//   wallet: (token) =>
//     apiFetch("/vendor/payouts/wallet.php", {
//       method: "GET",
//       token,
//     }),

//   // ✅ Request payout (NO balance restriction)
//   requestPayout: (token, amount) =>
//     apiFetch("/vendor/payouts/request.php", {
//       method: "POST",
//       token,
//       body: { amount: Number(amount) },
//     }),

//   // ✅ Payout history with optional filters
//   payoutHistory: (token, params = {}) => {
//     const query = new URLSearchParams(params).toString();
//     return apiFetch(`/vendor/payouts/history.php${query ? `?${query}` : ""}`, {
//       method: "GET",
//       token,
//     });
//   },

//   /* =========================
//      REVIEWS
//   ========================= */

//   reviewsList: (token, vendor_id) =>
//     apiFetch(
//       `/vendor/reviews/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
//       { method: "GET", token },
//     ),
// };

//updated file

import { apiFetch } from "./apiFetch";

export const vendorApi = {
  /* =========================
     AUTH / DASHBOARD
  ========================= */

  me: (vendorId, token) =>
    apiFetch(`/vendor/auth/me.php?id=${encodeURIComponent(vendorId)}`, {
      method: "GET",
      token,
    }),

  /* =========================
     PRODUCTS
  ========================= */

  products: (token, vendor_id) =>
    apiFetch(
      `/vendor/products/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
      { method: "GET", token },
    ),

  addProduct: (token, payload) =>
    apiFetch("/vendor/products/add.php", {
      method: "POST",
      token,
      body: payload,
    }),

  deleteProduct: (token, id) =>
    apiFetch("/vendor/products/delete.php", {
      method: "POST",
      token,
      body: { id },
    }),

  /* =========================
     CATEGORIES
  ========================= */

  mainCategories: (token) =>
    apiFetch("/vendor/main_categories/list.php", {
      method: "GET",
      token,
    }),

  subCategoriesByMain: (token, main_category_id) =>
    apiFetch(
      `/vendor/sub_categories/list.php?main_category_id=${encodeURIComponent(main_category_id)}`,
      { method: "GET", token },
    ),

  /* =========================
     ORDERS
  ========================= */

  orders: (token, vendor_id) =>
    apiFetch(
      `/vendor/orders/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
      { method: "GET", token },
    ),

  orderDetails: (token, order_id) =>
    apiFetch(
      `/vendor/orders/details.php?order_id=${encodeURIComponent(order_id)}`,
      { method: "GET", token },
    ),

  monthlyOrders: (token, year) => {
    const y = year || new Date().getFullYear();
    return apiFetch(
      `/vendor/orders/monthly.php?year=${encodeURIComponent(y)}`,
      { method: "GET", token },
    );
  },

  // ✅ UPDATED: now accepts an optional tracking_no.
  // When tracking_no is provided (e.g. status === "SHIPPED"), it's included
  // in the request body so the backend can save it alongside the status.
  // Make sure update_status.php reads $_POST['tracking_no'] (or the JSON
  // equivalent) and that your orders table has a tracking_no column.
  updateOrderStatus: (token, order_id, status, tracking_no = "", deliveryImage = null, deliveryVideo = null) => {
    if (deliveryImage || deliveryVideo) {
      const formData = new FormData();
      formData.append("order_id", order_id);
      formData.append("status", status);
      if (tracking_no) formData.append("tracking_no", tracking_no);
      if (deliveryImage) formData.append("delivery_image", deliveryImage);
      if (deliveryVideo) formData.append("delivery_video", deliveryVideo);

      return apiFetch("/vendor/orders/update_status.php", {
        method: "POST",
        token,
        body: formData,
      });
    }

    return apiFetch("/vendor/orders/update_status.php", {
      method: "POST",
      token,
      body: tracking_no ? { order_id, status, tracking_no } : { order_id, status },
    });
  },

  /* =========================
     PAYOUTS / WALLET
  ========================= */

  // ✅ Wallet fetch (USE THIS ONLY)
  wallet: (token) =>
    apiFetch("/vendor/payouts/wallet.php", {
      method: "GET",
      token,
    }),

  // ✅ Request payout (NO balance restriction)
  requestPayout: (token, amount) =>
    apiFetch("/vendor/payouts/request.php", {
      method: "POST",
      token,
      body: { amount: Number(amount) },
    }),

  // ✅ Payout history with optional filters
  payoutHistory: (token, params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiFetch(`/vendor/payouts/history.php${query ? `?${query}` : ""}`, {
      method: "GET",
      token,
    });
  },

  /* =========================
     REVIEWS
  ========================= */

  reviewsList: (token, vendor_id) =>
    apiFetch(
      `/vendor/reviews/list.php?vendor_id=${encodeURIComponent(vendor_id)}`,
      { method: "GET", token },
    ),
};